export default __webpack_public_path__ + "static/media/inspiration4.c1e5423f.jpg";